import React from "react";
import { Outlet } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import {useTheme } from "../../components/context/context";
import SideNav from "./SideNav";
import Carousel from "./Carousel";
import useWindowSize from "../../components/windowSize/useWindowSize";
import { Grid } from "@mui/material";
import TopNav from "./TopNav";
import Downloader from "../../components/pdf_downloader/Downloader";
import RelatedWebsites from "../home/RelatedWebsites";

export default function Layout() {
  const size = useWindowSize();
  const {spacing} = useTheme();
  return (
    <>
        <Navbar />
        <TopNav />
        <marquee direction="right">{list.map(data => (data))}</marquee> {/* Floating Notification */}
        <Carousel /> {/* Slider below the navbar */}
        <div style={{ width: "100%", display: "flex", justifyContent: "center",
          letterSpacing:spacing, wordSpacing:spacing*2 
          }}>
          <Grid container style={{ display: "flex", maxWidth: size > 915 ? "92%" : "95%", justifyContent: "space-between" }}>
            <Grid sm={size > 901 ? 2.5 : 12} xs={size > 901 ? 2.5 : 12}>
              <SideNav />{/* Side Navigation Bar */}
            </Grid>
            <Grid sm={size > 901 ? 9 : 12} xs={size > 901 ? 9 : 12} id="main-content">
              <Outlet /> {/* Outlet can be page- example when we are in dowload page <Outlet/> becomes <Download/>, if we are in gallery <Outlet/> becomes <Gallery/> and so on*/}
              {/* Note only outlet changes, and the rest remains the same, Navigation bar, sidenav etc */}
            </Grid>

            <div style={{ width: "100%" }}>
              <RelatedWebsites /> {/* Related websites above the footer */}
            </div>
          </Grid>
        </div>
        <Footer />

    </>
  );
}
const list = [
  <Downloader url={"pdf/new/Annual_Report_2024-2025.pdf"} name={"Annual Report of the Meghalaya Society for Social Audit and Transparency (MSSAT) for the Financial Year 2024-2025"} />
]